<template>
    <!--
        // for testing
        the payment form should submit successfully with this test data
        Name: Any Name / Jane Doe
        Card Number: 4111111111111111
        Expiration: Any future date
        AVS: Any 3 Digits

        // may need iframe sizing help...
        https://stackoverflow.com/questions/9975810/make-iframe-automatically-adjust-height-according-to-the-contents-without-using
        https://stackoverflow.com/questions/47391423/div-container-and-iframe-auto-height?rq=1
    -->
    <iframe
        v-on:load="loaded($event)"
        v-bind:src="iframeSrc"
        style="width:100%;min-height:800px;"
    ></iframe>
</template>

<script>
import random from "../lib/random";

export default {
    name: "TrustCommercePaymentFrame",
    props: {
        transactionError: {
            type: String,
            required: true
        },
        totalFee: {
            type: Number,
            required: true
        },
        successUrl: {
            type: String,
            required: true
        },
        paymentUrl: {
            type: String,
            required: true
        },
        licenseKey: {
            type: String,
            required: true
        },
        custId: {
            type: String,
            required: true
        },
        eventData: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    watch: {
        transactionError: {
            handler: function() {
                if (this.transactionError) {
                    this.$forceUpdate();
                }
            }
        }
    },
    computed: {
        iframeSrc() {
            let domain = this.paymentUrl;
            let path = "trustcommerce_payment/index.php";

            let queryParams = {
                trxcustid: this.custId,
                trxcustid_licensekey: this.licenseKey,
                amount: this.totalFee,
                ticketno: random(),
                hide_ticket: "y",
                googlepay: "y",
                applepay: "y",
                show_email: "y",
                email_address: this.formData.yourInfo.fields.email_address,
                CreditCard_saveLater: "n",
                is_redirect: "y",
                css_style: "1",
                response_url: [
                    window.location.protocol,
                    "//",
                    window.location.host,
                    this.successUrl
                ].join(""),
                "label_trxcustomfields[1]": "Event Name",
                "trxcustomfield[1]": this.eventData.title,
                "label_trxcustomfields[2]": "Event Date",
                "trxcustomfield[2]": this.formData.yourEvent.fields.event_date,
                "label_trxcustomfields[3]": "Department Names",
                "trxcustomfield[3]": this.list(
                    this.eventData.departments,
                    "title"
                ),
                "label_trxcustomfields[4]": "Department Numbers",
                "trxcustomfield[4]": this.list(
                    this.eventData.departments,
                    "number"
                ),
                "label_trxcustomfields[5]": "Department Revenue Accounts",
                "trxcustomfield[5]": this.list(
                    this.eventData.departments,
                    "revenueAccount"
                ),
                "label_trxcustomfields[6]": "Department Contacts",
                "trxcustomfield[6]": this.list(
                    this.eventData.departments,
                    "contact"
                ),
                "label_trxcustomfields[7]": "Event Activity",
                "trxcustomfield[7]": this.eventData.eventActivity,
                "label_trxcustomfields[8]": "Event Category",
                "trxcustomfield[8]": this.eventData.eventCategory,
                "label_trxcustomfields[9]": "phone number",
                "trxcustomfield[9]": this.formData.yourInfo.fields.phone_number,
                "label_trxcustomfields[10]": "email",
                "trxcustomfield[10]": this.formData.yourInfo.fields.email_address,
            };

            // Un-comment to inspect all query params in the console
            // console.table(queryParams);

            return `${domain}/${path}?${this.buildQueryString(queryParams)}`;
        }
    },
    methods: {
        list(list, key) {
            return list
                .map(item => {
                    return item[key];
                })
                .filter(Boolean)
                .join(", ");
        },
        buildQueryString(params) {
            return Object.keys(params)
                .map(key => {
                    return key + "=" + encodeURIComponent(params[key]);
                })
                .join("&");
        },
        loaded(event) {
            this.$emit("loaded", event);

            const frameWindow = event.target.contentWindow;
            const frameContent =
                event.target.contentDocument || frameWindow.document;

            if (frameContent) {
                const script = frameContent.getElementById(
                    "tcPaymentSuccessData"
                );

                if (script) {
                    const data = JSON.parse(script.innerHTML);

                    if (data["transaction[status_name]"] !== "approved") {
                        frameWindow.location = this.iframeSrc;
                    }

                    this.$emit("success", data);
                }
            }
        }
    }
};
</script>

<style></style>
